import {
  type Benefits,
  type BenefitsAPI,
  isBenefitPensionPercentageAPI,
} from '@omnipresentgroup/types';

export const transformBenefitsFromAPI = (benefits: BenefitsAPI): Benefits => ({
  benefits: benefits.benefits.map((benefit) => ({
    benefitEffectiveDate: benefit.benefit_effective_date,
    benefitsCurrency: benefit.benefits_currency,
    clientId: benefit.client_id,
    country: benefit.country,
    employeeExternalId: benefit.employee_external_id,
    employeeId: benefit.employee_id,
    employeeName: benefit.employee_name,
    employerCost: benefit.employer_cost,
    lspId: benefit.lsp_id,
    numberOfDependents: benefit.number_of_dependents,
    payrollPeriod: benefit.payroll_period,
    vendor: benefit.vendor,
    origin: benefit.origin,
    benefitType: benefit.benefit_type,
    ...(benefit.coverage && { coverage: benefit.coverage }),
    ...(benefit.employee_deduction && {
      employeeDeduction: benefit.employee_deduction,
    }),
    ...(benefit.mandatory && { mandatory: benefit.mandatory }),
    ...(benefit.package && { package: benefit.package }),
    ...(benefit.pension_details && {
      pensionDetails: isBenefitPensionPercentageAPI(benefit.pension_details)
        ? {
            employerPercentage: benefit.pension_details.employer_percentage,
            employeePercentage: benefit.pension_details.employee_percentage,
            employeeVoluntaryContributionPercentage:
              benefit.pension_details
                .employee_voluntary_contribution_percentage,
          }
        : {
            employerAmount: benefit.pension_details.employer_amount,
            employeeAmount: benefit.pension_details.employee_amount,
            employeeVoluntaryContributionAmount:
              benefit.pension_details.employee_voluntary_contribution_amount,
          },
    }),
  })),
  lastUpdated: benefits.last_updated,
});
